const defaultQrValue = (): string => '';

export default defaultQrValue;
